import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import api from "../api"; // ✅ import your axios instance

// ✅ Define columns for forms
const columns = [
  { name: "Merchant ID", selector: r => r.merchantId },
  { name: "Slug", selector: r => r.slug },
  { name: "Title", selector: r => r.title },
  { name: "Created At", selector: r => new Date(r.createdAt).toLocaleString() }
];

export default function FormsTable() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const loadForms = async () => {
      try {
const token = localStorage.getItem("jwt");

const res = await api.post(
  "/forms/fetchAllForms",{},
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }
);

        const apiData = res.data;

        // Handle both array and single object response
        const forms = Array.isArray(apiData) ? apiData : [apiData];

        // Sort by createdAt descending
        const sorted = forms.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        // Take latest 5
        setData(sorted.slice(0, 5));
      } catch (err) {
        console.error("Error fetching forms:", err);
      }
    };

    loadForms();
  }, []);

  return (
    <DataTable
      columns={columns}
      data={data}
      dense
      noHeader
    />
  );
}
